/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Custom audio file icon.
 * @export
 */

export const CUSTOM_FILE_AUDIO_ICON = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#CCE9ED" height="19" rx="1.5" stroke="#73C0CB" width="19" x="2.5" y="2.5" />
    <path
      d="M9.5 7.4798C9.5 7.24297 9.66616 7.03862 9.89802 6.99031L15.898 5.74031C16.2085 5.67563 16.5 5.91265 16.5 6.2298V7.5202C16.5 7.75703 16.3338 7.96138 16.102 8.00969L10.102 9.25969C9.79149 9.32437 9.5 9.08735 9.5 8.7702V7.4798Z"
      fill="#73C0CB"
      stroke="#057E91"
    />
    <path
      d="M9 8C9 7.44772 9.44772 7 10 7V16.5C10 16.7761 9.77614 17 9.5 17C9.22386 17 9 16.7761 9 16.5V8Z"
      fill="#057E91"
    />
    <circle cx="7.5" cy="16.5" fill="#73C0CB" r="2" stroke="#057E91" />
    <path d="M16 7L17 7.32V14.5C17 14.7761 16.7761 15 16.5 15C16.2239 15 16 14.7761 16 14.5V7Z" fill="#057E91" />
    <circle cx="14.5" cy="14.5" fill="#73C0CB" r="2" stroke="#057E91" />
  </svg>
);
